export const REMOVE_INAVAILABILITY_SUCCESS = 'REMOVE_INAVAILABILITY_SUCCESS';
export const INAVAILABILITY_CREATE_SUCCESS = 'INAVAILABILITY_CREATE_SUCCESS';
export const INAVAILABILITY_UPDATE_SUCCESS = 'INAVAILABILITY_UPDATE_SUCCESS';